import type { RUserProfile } from 'v2/types/api/settings'
import { canEmbedSessionTestAgent, type REmbedSession } from './embed-session'

// What PubNubProvider connects with. Pure, so both modes test without mounting it.
export interface PubnubIdentity {
  authed: boolean
  publishKey?: string
  subscribeKey?: string
  // Must equal the token's authorized uuid, or PubNub refuses the client.
  userId: string
  tokenKey: string
  channels: string[]
}

export const consolePubnubIdentity = (
  profile: RUserProfile | undefined,
  userAuthenticated: boolean,
): PubnubIdentity => {
  const org = profile?.organizations?.[0]
  const { publish_key: publishKey, subscribe_key: subscribeKey } = org?.pubnub_keyset_data || {}
  const aomId = org?.id
  const channels = aomId ? [`aom.${aomId}`] : []
  const orgId = org?.org_id
  if (orgId) channels.push(`org.${orgId}`)
  return {
    authed: userAuthenticated,
    publishKey,
    subscribeKey,
    userId: aomId || '',
    tokenKey: aomId || '',
    channels,
  }
}

// Embed has no profile, so session/me supplies the keys. Realtime only serves the Test agent, so
// only a session that may run it connects; the token is minted per session, hence the cache key.
export const embedPubnubIdentity = (session: REmbedSession | null): PubnubIdentity => {
  const orgUuid = session?.org_uuid ?? ''
  const aomUuid = session?.aom_uuid
  const publishKey = session?.pubnub_publish_key
  const subscribeKey = session?.pubnub_subscribe_key
  return {
    authed: Boolean(
      canEmbedSessionTestAgent(session) && orgUuid && aomUuid && publishKey && subscribeKey,
    ),
    publishKey,
    subscribeKey,
    userId: orgUuid,
    tokenKey: session?.session_id ?? '',
    channels: aomUuid ? [`aom.${aomUuid}`] : [],
  }
}
